import { Box, Typography } from "@mui/material";
import React from "react";

const Rejection = ({
  locationData,
  setIsEditable,
  isEditable,
  setIsPersonalEditable,
  setIsFinanceEditable,
  isActivetab,
  setIsReadOnly,
  setDrIsReadOnly,
  setshowApproval,
}) => {
  const handleControll = () => {
    if (locationData?.locationData?.dataType === "CENTER") {
      locationData?.setIsEditable(true);
      setIsEditable(true);
      setIsReadOnly((c) => !c);
      setshowApproval(false);
    } else if (locationData?.dataType === "PROFESSIONAL") {
      if (isActivetab === "FINANCE") {
        // setIsEditable(true);
        setDrIsReadOnly((c) => !c);
        setshowApproval(false)
      } else if (isActivetab === "MEDICAL") {
        setIsPersonalEditable(true);
      }
    }
  };

  return (
    <Box padding={"0px 0px 20px 0px"}>
      <Typography
        color={"#F66C61"}
        fontSize={"16px"}
        fontWeight={"600"}
        paddingBottom={2}>
        Reason for Rejection
      </Typography>
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <Box
          width={"100%"}
          border={"solid 1px #E56B00"}
          borderRadius={"10px"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          padding={"20px"}
          bgcolor={"#FFEAD8"}>
          <Typography fontSize={"12px"} width={"80%"} fontWeight={"600"}>
            {locationData?.locationData?.rejectedReason ||
              locationData.rejectedReason}
          </Typography>
          {/* {!locationData?.locationDatas?.isShowEditDetail && ( */}
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-around"}
            fontSize={"14px"}
            width={"150px"}
            bgcolor={"#414851"}
            height={"30px"}
            color={"white"}
            borderRadius={"8px"}
            padding={1}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleControll()}>
            Edit Details
          </Box>
          {/* )} */}
        </Box>
      </Box>
    </Box>
  );
};

export default Rejection;
